import React, { useEffect, useState } from "react";
import "./Header.css";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEllipsisV, faLock, faUser } from '@fortawesome/free-solid-svg-icons'
import { Link, NavLink, useLocation } from "react-router-dom";
import { isLogIn } from "../../config/Api";
import logoLogin from "../../assets/images/logo_login.png";
import * as Apis from "../../config/Api";
import { constants } from "../../config/constants";
import _ from "underscore";

const HeaderMobile = ({ headerClass, loginClass, main_class }) => {
    const [detail, setDetail] = useState({})
    const location = useLocation()
    // const getAccountDetail = () => {
    //     Apis.GetApiMethod(constants.ACCOUNT_DETAILS).then(res => {
    //         if (res.error === true) {
    //             if (res.response.data.error.toLowerCase() === "wrong token" || res.response.data.error.toLowerCase() === "user does not exist") {
    //                 Apis.logout()
    //             }
    //         } else {
    //             setDetail(res.data)
    //         }
    //     })
    // }

    const toggleClick = () => {
        document.body.classList.remove('account_menu_open')
        document.body.classList.toggle('nav_open')
    }
    const toggleAccount = () => {
        document.body.classList.remove('nav_open')
        document.body.classList.toggle('account_menu_open')
    }
    
    useEffect(() => {
        // getAccountDetail()
        document.body.classList.remove('nav_open')
        document.body.classList.remove('account_menu_open')
    }, [location.pathname])

    return (
        <header className={`main_header ${headerClass}`}>
            <div className="container">
                <nav className={`navbar navbar-default mainheader`}>
                    <div>
                        <button type="button" onClick={toggleClick} className="navbar_toggle" data-toggle="collapse" data-target="#navbar" aria-expanded="false" aria-controls="navbar">
                            <span className="icon-bar"></span>
                            <span className="icon-bar"></span>
                            <span className="icon-bar"></span>
                        </button>
                    </div>
                    <div className="navbar-header">
                        {headerClass === 'loginpage' ?
                            <Link className="navbar-brand main-logo" to="/"></Link>
                            :
                            <Link className="navbar-brand" to="/">
                                <img src={logoLogin} alt="" className="img-fluid" width={100} />
                            </Link>
                        }
                    </div>
                    <div>
                        {isLogIn().isToken === false ?
                            <div className="login logbtn text-end">
                                <Link to="login" className="login_dropmenu"><FontAwesomeIcon icon={faLock} style={{ fontSize: "13px" }} /> Login</Link>
                            </div>
                            :
                            <div className="loginDropmenu text-end">
                                <div className="login logbtn white_login">
                                    <button className="login_dropmenu" onClick={toggleAccount}><FontAwesomeIcon icon={faEllipsisV} /></button>
                                </div>
                                <div className="loginDropDown">
                                    {isLogIn().isToken &&
                                        <Link to="/my-account">My Account</Link>
                                    }
                                    <Link to="/logout-successfully"><FontAwesomeIcon icon={faLock} style={{ fontSize: "13px", marginRight: "5px" }} /> Logout</Link>
                                </div>
                            </div>
                        }
                    </div>
                </nav>
            </div>
            <div id="navbar">
                <ul className={`nav headrow align-items-center ${loginClass}`}>
                    <li className="">
                        <NavLink to="/download-desktop-application">Download App</NavLink>
                    </li>
                    <li className="">
                        <NavLink to="/wordpress-plugin">WordPress Plugin</NavLink>
                    </li>
                    <li className="">
                        <NavLink to="/developer-api">Developer API</NavLink>
                    </li>
                </ul>
            </div>
        </header >
    )
}

export default HeaderMobile;